var map = {
	".": "Ow07",
	"./": "Ow07",
	"./00_post_trade_order": "JG85",
	"./00_post_trade_order.json": "JG85",
	"./01_get_commissionRate": "3Csz",
	"./01_get_commissionRate.json": "3Csz",
	"./01_get_leverage": "6Wqe",
	"./01_get_leverage.json": "6Wqe",
	"./03_post_leverage": "HWdZ",
	"./03_post_leverage.json": "HWdZ",
	"./04_post_allOpenOrders": "xM9z",
	"./04_post_allOpenOrders.json": "xM9z",
	"./05_post_closeAllPositions": "A11g",
	"./05_post_closeAllPositions.json": "A11g",
	"./06_get_positions": "Uqg4",
	"./06_get_positions.json": "Uqg4",
	"./07_get_balance": "DyCG",
	"./07_get_balance.json": "DyCG",
	"./08_get_forceOrders": "79Xw",
	"./08_get_forceOrders.json": "79Xw",
	"./09_get_allFillOrders": "KXGF",
	"./09_get_allFillOrders.json": "KXGF",
	"./10_delete_trade_order": "Mwlf",
	"./10_delete_trade_order.json": "Mwlf",
	"./11_get_all_openOrders": "Ui0Y",
	"./11_get_all_openOrders.json": "Ui0Y",
	"./12_get_trade_order": "nj2w",
	"./12_get_trade_order.json": "nj2w",
	"./14_get_trade_allOrders": "BW7b",
	"./14_get_trade_allOrders.json": "BW7b",
	"./15_get_margin_type": "Qb5x",
	"./15_get_margin_type.json": "Qb5x",
	"./16_post_margin_type": "dI3A",
	"./16_post_margin_type.json": "dI3A",
	"./17_post_trade_positionMargin": "2WEb",
	"./17_post_trade_positionMargin.json": "2WEb",
	"./index": "Ow07",
	"./index.js": "Ow07"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JOF7";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/trade ^.*$
// module id = JOF7
// module chunks = 3